(ns app.front.view.group.admin.property.config.core
  (:require [app.front.entities :as entities]
            [app.front.view.group.admin.common :as acommon]
            [app.front.view.group.admin.core :as acore]
            [app.front.view.group.admin.gis-source-config :as gis-source-config]
            [app.front.view.group.admin.property.config.attachments :as admin-property-attachment-config]
            [app.front.view.group.admin.property.config.attributes :as admin-property-config-attrs]
            [app.front.view.group.admin.property.config.unit-designators :as unit-designator-config]
            [app.front.view.group.admin.subs :as gas]
            [core.front.event :refer [<sub >evt]]
            [core.front.feature-flags :as ff]
            [core.util.util :as util]
            [re-frame.core-instrumented :as rf]))

(rf/reg-event-fx ::fetch-templates
  (fn [_ [_ group-id]]
    {:comm/command {:command    :group/property-attribute-templates
                    :method     :get
                    :data       {:group-id group-id}
                    :on-success [::entities/merge-entity-db]}}))

(rf/reg-event-fx ::fetch-attachment-types
  (fn [_ [_ group-id]]
    (let [command :group/attachment-types]
      {:fx [[:dispatch [::acore/set-fetching-config group-id command]]
            [:comm/command {:command    command
                            :method     :get
                            :data       {:group-id group-id}
                            :on-success [::fetch-attachment-types.success group-id command]}]]})))

(rf/reg-event-fx ::fetch-attachment-types.success
  (fn [{:keys [db]} [_ group-id command status {:keys [entities types-in-use]}]]
    {:db (assoc-in db [::gas/config-defaults :types-in-use] types-in-use)
     :fx [[:dispatch [::acore/config-fetched group-id command status entities]]]}))

(rf/reg-event-fx ::fetch-unit-designators
  (fn [_ [_ group-id]]
    {:comm/command {:command    :group/unit-designators
                    :method     :get
                    :data       {:group-id group-id}
                    :on-success [::fetch-unit-designators.success]}}))

(rf/reg-event-fx ::fetch-unit-designators.success
  (fn [{:keys [db]} [_ status {:keys [entities unit-designators-in-use]}]]
    {:db (assoc-in db [::gas/config-defaults :unit-designators-in-use] unit-designators-in-use)
     :fx [[:dispatch [::entities/merge-entity-db status entities]]]}))

(defn view [match]
  (let [advanced? (or (<sub [:session/admin?])
                      (<sub [::gas/group-or-descendant-has-feature? :group.feature/property-management]))
        tabs      (remove nil? [(when (ff/enabled? :feature-flag.id/configure-gis-source)
                                  [:property-mgmt-config.tabs/gis-config gis-source-config/view])
                                (when (ff/enabled? :feature-flag.id/property-db-units)
                                  [:property-mgmt-config.tabs/unit-designators unit-designator-config/view])
                                (when advanced?
                                  [:property-mgmt-config.tabs/attributes admin-property-config-attrs/tab-content])
                                (when (and advanced? (ff/enabled? :feature-flag.id/property-attachments))
                                  [:property-mgmt-config.tabs/attachments admin-property-attachment-config/attachments-content])])]
    [acommon/admin-page-v2 (util/mmap {:wait-for-group?     true
                                       :allowed-group-types #{:group.type/domain}}
                                      match tabs)]))

(def route
  (acommon/standard-route-definition {:name        :view/group.admin.property-mgmt-config
                                      :view        view
                                      :controllers [{:parameters {:path [:group-id]}
                                                     :start      (fn [{{:keys [group-id]} :path}]
                                                                   (>evt [::fetch-templates group-id])
                                                                   (>evt [::fetch-attachment-types group-id])
                                                                   (>evt [::gas/fetch-authority-groups group-id])
                                                                   (>evt [::admin-property-config-attrs/fetch-template-settings group-id])
                                                                   (>evt [::fetch-unit-designators group-id]))}]}))
